export const GET_USER_SAGA = 'GET_USER_SAGA';
export const GET_SESSION_SAGA = 'GET_SESSION_SAGA';
export const LOGOUT_USER_SAGA = 'LOGOUT_USER_SAGA';

export const GET_ADMIN_SESSION_SAGA = 'GET_ADMIN_SESSION_SAGA';
export const LOGOUT_ADMIN_SAGA = 'LOGOUT_ADMIN_SAGA';
